<template>
  <div>
    <DxPopup
      :visible="enabledPopUpManure"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="auto"
      height="auto"
      :title="$t('registerProject.registerProjectGreenHouse.title_groupItem_manure')"
    >
      <DxScrollView
        scroll-by-content
        scroll-by-thumb
        direction="both"
      >
        <div class="content-devx transparent">
          <DxForm>
            <DxGroupItem
              :col-count="1"
            >
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.name')"
                :editor-options="{
                  onValueChanged: onChangeName,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.totalContentN')"
                :editor-options="{
                  onValueChanged: onChangeTotalContent,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.dryMatter')"
                :editor-options="{
                  onValueChanged: onChangeDryMatter,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.density')"
                :editor-options="{
                  onValueChanged: onChangeDensity,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.mineralizationRateYear1')"
                :editor-options="{
                  onValueChanged: onChangeMineralizationRateYear1,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.mineralizationRateYear2')"
                :editor-options="{
                  onValueChanged: onChangeMineralizationRateYear2,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.mineralizationRateYear3')"
                :editor-options="{
                  onValueChanged: onChangeMineralizationRateYear3,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupManure.mineralizationRateYear4')"
                :editor-options="{
                  onValueChanged: onChangeMineralizationRateYear4,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
            </DxGroupItem>
          </DxForm>
        </div>
        <f7-block-footer
          class="content-action-botton"
        >
          <f7-button
            class="dx-btn-cancel margin-right"
            raised
            type="default"
            text-color="grey"
            styling-mode="outlined"
            name="ButtonCancel"
            @click="closePopUp"
          >
            {{ $t('EditOrder_ButtonCancel_caption') }}
          </f7-button>
          <f7-button
            :class="`dx-btn-success ${enabled ? '' : 'disabled'}`"
            raised
            type="success"
            styling-mode="contained"
            name="ButtonSave"
            @click="enabled ? followForm() : null"
          >
            {{ $t("EditOrder_ButtonSave_caption") }}
          </f7-button>
        </f7-block-footer>
      </DxScrollView>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import {
  DxForm, DxSimpleItem, DxGroupItem, DxRequiredRule,
} from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';

export default {
  name: 'ManureFormPopUp',
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxScrollView,
  },
  data() {
    return {
      newManure: {
        name: '',
        dryMatter: '',
        contentTotal: '',
        density: '',
        mineralizationRateYear1: '',
        mineralizationRateYear2: '',
        mineralizationRateYear3: '',
        mineralizationRateYear4: '',
      },
      enabled: false,
    };
  },
  computed: {
    ...mapState('ProjectGreenHouse', ['enabledPopUpManure', 'manure']),
  },
  methods: {
    validate() {
      this.enabled = !!(
        this.newManure.name
          && this.newManure.N
          && this.newManure.dry
          && this.newManure.density
          && this.newManure.year_1
          && this.newManure.year_2
          && this.newManure.year_3
          && this.newManure.year_4
      );
    },
    onChangeName(e) {
      this.newManure.name = e.value;
      this.validate();
    },
    onChangeTotalContent(e) {
      this.newManure.N = e.value;
      this.validate();
    },
    onChangeDryMatter(e) {
      this.newManure.dry = e.value;
      this.validate();
    },
    onChangeDensity(e) {
      this.newManure.density = e.value;
      this.validate();
    },
    onChangeMineralizationRateYear1(e) {
      this.newManure.year_1 = e.value;
      this.validate();
    },
    onChangeMineralizationRateYear2(e) {
      this.newManure.year_2 = e.value;
      this.validate();
    },
    onChangeMineralizationRateYear3(e) {
      this.newManure.year_3 = e.value;
      this.validate();
    },
    onChangeMineralizationRateYear4(e) {
      this.newManure.year_4 = e.value;
      this.validate();
    },
    closePopUp() {
      this.onHidden();
    },
    async followForm() {
      try {
        this.$f7.preloader.show();
        await this.createDatabaseManure(this.newManure);
        this.onHidden();
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onHidden() {
      this.setEnabledPopUpManure(false);
    },
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpManure', 'createDatabaseManure']),
  },
};
</script>
<style lang="scss" scoped>
</style>
